import { Button, Form, FormRule, Input, Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { onError } from "src/common/onError";
import { activateByPath } from "src/components/MForm/formNav/activateByPath";
import { findDataNode } from "src/components/MForm/formNav/findDataNode";
import { MFormStore } from "src/components/MForm/MFormStore";
import { str2MfPath } from "src/components/MForm/MFormTypes";

type PropsFindFieldByPath = {
  formStore: MFormStore;
};

export const FindFieldByPath: React.FC<PropsFindFieldByPath> = observer(
  ({ formStore }) => {
    const [open, setOpen] = React.useState(false);
    return (
      <>
        <Button size="small" onClick={() => setOpen(true)}>
          Path
        </Button>
        <Modal
          title="Поиск поля по пути"
          open={open}
          onCancel={() => setOpen(false)}
          okButtonProps={{
            htmlType: "submit",
          }}
          modalRender={(content) => (
            <Form
              layout="vertical"
              onFinish={({ path }) => {
                setOpen(false);
                setTimeout(() => {
                  const dataPath = str2MfPath(path);
                  activateByPath(formStore.root, dataPath).catch(onError);
                }, 200);
              }}
            >
              {content}
            </Form>
          )}
        >
          <Form.Item
            name="path"
            label="Path"
            rules={[{ required: true }, pathValidator(formStore)]}
          >
            <Input allowClear />
          </Form.Item>
        </Modal>
      </>
    );
  },
);

const pathValidator = (formStore: MFormStore): FormRule => ({
  validator: async (_, value) => {
    if (value && typeof value === "string") {
      const node = findDataNode(formStore.root, str2MfPath(value));
      if (!node) throw Error("Некорректный путь");
    }
  },
});
